import React from 'react';
import { Box, ButtonGroup, Flex, IconButton, Text } from '@chakra-ui/react';

import { CiStar } from 'react-icons/ci';
import { MdOutlineEmail } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { IoFilterOutline } from 'react-icons/io5';
import { FaChevronLeft } from 'react-icons/fa6';

import { FaRegStar } from 'react-icons/fa6';

import { useSelector, useDispatch } from 'react-redux';
import { setMobileView } from '../../redux/actions/responsiveActions';

const ThreadHeader = () => {
  const dispatch = useDispatch();

  const isMobile = useSelector((s) => s?.responsive?.isMobile);
  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);

  return (
    <Box>
      <Flex
        justifyContent="space-between"
        px={3}
        borderBottom="solid 1px #e3e3e3"
        py={3}
      >
        <Box>
          {!isMobile ? (
            <Text fontWeight={600} fontSize={14} lineHeight={10}>
              {activeProspect?.firstName || 'No Name'}{' '}
              {activeProspect?.lastName}
            </Text>
          ) : (
            <Flex alignItems={'center'}>
              <Box
                mr="10px"
                onClick={() => {
                  dispatch(setMobileView('rooms'));
                }}
              >
                <Flex alignItems="center">
                  <FaChevronLeft /> Back
                </Flex>
              </Box>
              <Box
                onClick={() => {
                  dispatch(setMobileView('info'));
                }}
              >
                <Text fontWeight={600} fontSize={14} lineHeight={10}>
                  {activeProspect?.firstName || 'No Name'}{' '}
                  {activeProspect?.lastName}
                </Text>
              </Box>
            </Flex>
          )}
        </Box>
        <Box alignItems="center" display="flex">
          <ButtonGroup size="sm" isAttached variant="outline">
            <IconButton
              border="solid 1px #e3e3e3"
              height={10}
              width={10}
              _hover={{ background: '#854dff', color: 'white' }}
              color="#787878"
              backgroundColor="white"
              fontWeight={400}
              aria-label="Previous Double"
              icon={<FaRegStar fontSize={17} />}
            />

            <IconButton
              border="solid 1px #e3e3e3"
              height={10}
              width={10}
              _hover={{ background: '#854dff', color: 'white' }}
              color="#787878"
              backgroundColor="white"
              fontWeight={400}
              aria-label="Calendar"
              icon={<RiDeleteBin6Line fontSize={18} />}
            />
          </ButtonGroup>
        </Box>
      </Flex>
    </Box>
  );
};

export default ThreadHeader;
